'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _VoucherCard = require('./VoucherCard');

var _VoucherCard2 = _interopRequireDefault(_VoucherCard);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _support = require('helpers/support');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_BOX_NUMBER = 4;
var VoucherHorizontalList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    province: state.address.province,
    categories: state.setup.categories,
    loading: state.voucher.loading,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST
  };
}, (0, _extends3.default)({}, voucherActions, { shopActions: shopActions })), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VoucherHorizontalList, _Component);

  function VoucherHorizontalList(props) {
    (0, _classCallCheck3.default)(this, VoucherHorizontalList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VoucherHorizontalList.__proto__ || (0, _getPrototypeOf2.default)(VoucherHorizontalList)).call(this, props));

    _this.state = {
      firstLoad: false,
      category: [],
      promotionDetail: _this.props.promotionDetail || false
    };

    _this.getResult = _this.getResult.bind(_this);
    _this.renderCampaigns = _this.renderCampaigns.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(VoucherHorizontalList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loading || !this.props.ALL_REWARD_LIST || !this.state.firstLoad) {
        this.getResult();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading) {
        this.setState({ firstLoad: true });
      }
      if (nextProps.province !== this.props.province) {
        this.getResult(nextProps.province);
      }
    }
  }, {
    key: 'getResult',
    value: function getResult(province) {
      var filter = {
        category: this.state.category.join(','),
        province: province ? province : this.props.province,
        pageSize: this.props.boxNumber || DEFAULT_BOX_NUMBER
      };
      console.log('getAllReward', filter);
      this.props.getAllReward(filter);
    }
  }, {
    key: 'isActiveCategory',
    value: function isActiveCategory(cat) {
      return this.state.category.length === 0 || this.state.category.indexOf(cat) !== -1;
    }
  }, {
    key: 'activeCategory',
    value: function activeCategory(cat) {
      var category = [cat];
      if (this.state.category.indexOf(cat) !== -1) {
        category = [];
      }
      this.setState({ category: category });
      this.props.getAllReward({
        category: category.join(','),
        province: this.props.province,
        pageSize: this.props.boxNumber || DEFAULT_BOX_NUMBER
      });
    }
  }, {
    key: 'renderCampaign',
    value: function renderCampaign(item, index) {
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 col-md-3', key: '' + index },
        _react2.default.createElement(_VoucherCard2.default, { data: item })
      );
    }
  }, {
    key: 'renderCampaigns',
    value: function renderCampaigns() {
      var _this2 = this;

      var _props = this.props,
          data = _props.ALL_REWARD_LIST.data,
          boxNumber = _props.boxNumber,
          voucherHandle = _props.voucherHandle;

      var listPackages = [];
      if (data && data.length) {
        data.forEach(function (packSer) {
          var pack = _support.Helper.parsePackageServiceToCard(packSer);
          listPackages.push(pack);
        });
        if (listPackages && listPackages.length) {
          listPackages = listPackages.filter(function (pack) {
            return pack.handle !== voucherHandle;
          });
          var sliceIndex = boxNumber || DEFAULT_BOX_NUMBER;
          listPackages = _lodash2.default.slice(listPackages, 0, sliceIndex);
          return listPackages.map(function (item, index) {
            return _this2.renderCampaign(item, index);
          });
        }
      }
      var result = [];
      for (var index = 0; index < (boxNumber || DEFAULT_BOX_NUMBER); index++) {
        result.push(_react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-md-3', key: '' + index },
          _react2.default.createElement(_VoucherCard2.default, null)
        ));
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var promotionDetail = this.state.promotionDetail;

      var styles = require('./Box.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.box },
        _react2.default.createElement(
          'div',
          { className: styles.headerBox },
          _react2.default.createElement(
            'div',
            { className: styles.left },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: 'uu-dai' },
              promotionDetail ? _react2.default.createElement(
                'h2',
                { className: styles.leftHeaderTab },
                _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'tag' }),
                '\u01AFu \u0111\xE3i c\xF9ng chuy\xEAn m\u1EE5c'
              ) : _react2.default.createElement(
                'h2',
                { className: styles.title },
                '\u01AFu \u0110\xE3i'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.right },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: 'uu-dai' },
              _react2.default.createElement(
                'div',
                { className: styles.seeMore },
                'Xem th\xEAm',
                _react2.default.createElement(_reactBootstrap.Glyphicon, (0, _defineProperty3.default)({
                  className: styles.arrowRight,
                  glyph: 'menu-right'
                }, 'className', styles.arrowRight))
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyBox + ' row' },
          this.renderCampaigns()
        )
      );
    }
  }]);
  return VoucherHorizontalList;
}(_react.Component), _class2.propTypes = {
  promotion: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  province: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  boxNumber: _react.PropTypes.number,
  promotionDetail: _react.PropTypes.bool,
  ALL_REWARD_LIST: _react.PropTypes.object,
  getAllReward: _react.PropTypes.func.isRequired,
  voucherHandle: _react.PropTypes.string
}, _temp)) || _class);
exports.default = VoucherHorizontalList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/VoucherHorizontalList.js
// module id = 709
// module chunks = 0